export default __webpack_public_path__ + "static/media/somwhere.dd68bb77.gif";